import { useActive, useCommands } from '@remirror/react-core';
import { CommandButton } from './../CommandButton';
import { BoldOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';

export const BoldButton = React.memo(() => {
  const { toggleBold } = useCommands();

  const handleSelect = useCallback(() => {
    if (toggleBold.enabled()) {
      toggleBold();
    }
  }, [toggleBold]);

  const active = useActive().bold();
  const enabled = toggleBold.enabled();

  return (
    <CommandButton
      aria-label={'Bold'}
      icon={<BoldOutlined />}
      active={active}
      enabled={enabled}
      onClick={handleSelect}
    />
  );
});

export default BoldButton;
